import { useMainChartStore } from './store';

export const initializeMainChartStore = () => {
  const { loadMainChart } = useMainChartStore.getState();
  loadMainChart();
};